const BusinessOwnerFunctions = (() => {
    const handleValues = (value) => {
        const returnValue = {
            businessOwnerPlatformUserId: null,
            managed3rdParty: false,
            managedByPartner: false,
            noBusinessOwnerRequired: false
        };

        if (value === 'No Business Owner Required') {
            returnValue.noBusinessOwnerRequired = true;
        } else if (value === 'Managed By Partner') {
            returnValue.managedByPartner = true;
        } else if (value === 'Managed By 3rd Party') {
            returnValue.managed3rdParty = true;
        } else if (value === 'notAssigned') {
            returnValue.businessOwnerPlatformUserId = null;
        } else {
            returnValue.businessOwnerPlatformUserId = value;
        }

        return returnValue;
    };

    const noBusinessOwnerRequiredValue = {
        id: 'No Business Owner Required',
        name: 'No Business Owner Required'
    };

    const managedByPartnerValue = {
        id: 'Managed By Partner',
        name: 'Managed By Partner'
    };

    const managed3rdPartyValue = {
        id: 'Managed By 3rd Party',
        name: 'Managed By 3rd Party'
    };

    const notAssigned = {
        id: 'notAssigned',
        name: 'Not Assigned'
    };

    return {
        handleValues,
        managed3rdPartyValue,
        managedByPartnerValue,
        noBusinessOwnerRequiredValue,
        notAssigned
    };
})();

export default BusinessOwnerFunctions;
